module.exports = __webpack_public_path__ + "img/new_beijing_2.96dbf92e.jpg";